import React, { useEffect, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Notfound from "components/common/ErrorsPages/NotfoundPage";
import SystemParamSystem from "components/SystemParamsSocket";
import { getUserFromToken, getTimeZone } from "redux/actions";
import { fetchSystemParams } from "redux/actions";
import routes from "./routes";
import { REINIT_TOAST_ALERT } from "redux/constants";
import PrivateRouter from "./PrivateRoute";
import CheckSelectedRoles from "./CheckSelectedRoles";
import AuthorizationRoute from "./AuthorizationRoute";
import InfoModal from "components/common/modal_manager/info";
import "../components/admin_dashboard/main.css"

const AppRoutes = () => {
  const navigate = useNavigate();
  const { token, user } = useSelector((state) => state.auth);
  const { message, type, back } = useSelector((state) => state.TostAlert);

  const redirectToAccounts = () => {
    navigate("/");
  };

  useEffect(() => {
    dispatch(getUserFromToken(redirectToAccounts));
    dispatch(fetchSystemParams());
    dispatch(getTimeZone());
  }, [token]);

  const dispatch = useDispatch();

  const handleClose = () => {
    back && window.history.back();
    dispatch({ type: REINIT_TOAST_ALERT });
  };

  return (
    <div className="main-container">
      <Suspense fallback="Loading...">
        {message && (
          <InfoModal
            message={message}
            cb={handleClose}
            icon="info"
            color={type === "error" ? "red" : "green"}
          />
        )}
        <Routes>
          {routes.map(
            ({ component: Component, path, name, permission, ...rest }) => (
              <Route
                key={path}
                path={path}
                {...rest}
                element={
                  <PrivateRouter>
                    {user?.id && (
                      <CheckSelectedRoles path={path}>
                        <SystemParamSystem />
                        {name ? (
                          <AuthorizationRoute
                            name={name}
                            permission={permission}
                          >
                            <Component />
                          </AuthorizationRoute>
                        ) : (
                          <Component />
                        )}
                      </CheckSelectedRoles>
                    )}
                  </PrivateRouter>
                }
              />
            ),
          )}
          {user?.id && (
            <Route
              path="*"
              element={
                <PrivateRouter>
                  <Notfound />
                </PrivateRouter>
              }
            />
          )}
        </Routes>
      </Suspense>
    </div>
  );
};

export default AppRoutes;
